export default [
  {
    path: '/settings/preferencias',
    name: 'settings-preferencias',
    component: () => import('@/views/sistema/preferencias/Preferencias.vue'),
    meta: {
      pageTitle: 'Preferências',
      breadcrumb: [
        { text: 'Configurações' },
        { text: 'Preferências', active: true },
      ],
      resource: 'Preferencias',
      action: 'read',
    },
  },
];
